export default __webpack_public_path__ + "static/media/QF_logoHrz_tag.d56f3c5f.png";